import Template from 'backbone/story/templates/assets/video_field.js.hamlc'
import AssetDeleteConfirmationTemplate from 'backbone/story/templates/assets/asset_delete_confirmation.js.hamlc'
import VideoCommentView from 'backbone/story/views/comments/video_comment_view.js'
import S3MultipartUploaderView from 'backbone/story/views/assets/s3_multipart_uploader_view.js'
import StoryAssetsMixin from 'backbone/story/mixins/story_assets_mixin.js'
import videojs from 'video.js'
import Asset from 'backbone/platform/models/assets/asset.js'
import SingleAssetPickerView from 'backbone/platform/views/assets/single_asset_picker_view.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class VideoFieldView extends Backbone.View
  events:
    "click .js-attach"         : "showAssetPicker"
    "click .js-remove-asset"   : "onDelete"

  initialize: (options) ->
    StoryAssetsMixin.applyMixin(this)

    @options = options
    @assetableId = @options.asset.assetableId
    @allowAdd = @options.asset.allowDelete
    @asset = new Asset(@options.asset)
    @playerId = "js-player-field-#{@assetableId}-player"
    @commentCollection = page.get("storyComments")
    @listenTo(@asset, "change", @render)
    @_initUploader()
    @_bindDispatcher()
    @render()

  render: =>
    @player.dispose() if @player

    @$el.html(
      Template({
        asset: @asset,
        playerId: @playerId,
        allowAdd: @allowAdd,
        AssetDeleteConfirmationTemplate: AssetDeleteConfirmationTemplate
      })
    )

    if @asset.get("persisted")
      @player = videojs(
        @playerId,
        {
          controlBar: {
            volumePanel: { inline: false }
          }
        }
      )

      @player.on("loadedmetadata", (e) =>
        $("##{@playerId}").addClass("vjs-has-started")
        @commentCollection.onFetched(@_initVideoCommentView)
      )

      $(@player.el()).on("click", (e) -> e.stopPropagation())

  remove: =>
    @_removeCommentView()
    @player.dispose()
    @undelegateEvents()
    @_teardownDispatcher()
    super()

  showAssetPicker: ->
    @assetPicker = new SingleAssetPickerView
      el: $("#asset-picker-modal .asset-content")
      mediaLibraryAccess: false
      acceptedFormats: ["video/mp4"]
      inputId: "multipart-asset-uploader-Field-#{@assetableId}"
      modalHeaderTitle: "Attach a video"
      modalAttachText: "MP4 up to 20GB"

  onDelete: =>
    @$el.closest(".delete-confirmation-wrapper").removeClass("delete-queue")

    @asset.destroy
      success: =>
        @_removeCommentView()
        @player = @player.dispose()
        @assetRemoved()

  s3UploadStart: (upload) ->
    contently.ui.closeModal() if @assetPicker
    @showAssets()

  _setAssetAndRender: (asset) =>
    @stopListening(@asset, "change:processing", @render)
    @asset = asset
    @render() if @asset.get("processing")
    @listenTo(@asset, "change:processing", @render)

  _ifUploadMatchesView: (callback, data) ->
    if data.fileInputElement == @options.inputId
      callback.call(this, data)

  assetRemoved: =>
    @asset = new Asset
      assetableType: "Field"
      assetableId: @options.asset.assetableId
      allowDelete: @options.asset.allowDelete
    @render()
    @reloadAssets()

  _initUploader: ->
    new S3MultipartUploaderView(
      el: $(@options.inputId),
      bucket: @options.bucket,
      contextData: {
        assetableId: @assetableId,
        assetableType: "Field",
        assetType: "video"
      },
      onProcessingStart: @_setAssetAndRender
    )

  _bindDispatcher: ->
    @dispatcher = BackboneDispatcher.get_instance()
    @dispatcher.on("multipartS3UploadsComplete", @_ifUploadMatchesView.bind(this, @reloadAssets))
    @dispatcher.on("s3UploadStart", @_ifUploadMatchesView.bind(this, @s3UploadStart))

  _teardownDispatcher: () ->
    @dispatcher.off("multipartS3UploadsComplete", @_ifUploadMatchesView.bind(this, @reloadAssets))
    @dispatcher.off("s3UploadStart", @_ifUploadMatchesView.bind(this, @s3UploadStart))

  _initVideoCommentView: =>
    return if @videoCommentView

    @$el.addClass("js-comments-loaded")

    @videoCommentView = new VideoCommentView(
      el: @$el
      asset: @asset
      videoElId: @playerId
      player: @player
    )

  _removeCommentView: =>
    if @videoCommentView
      @videoCommentView.remove(false)
      @videoCommentView = null
      $(@player.el()).unbind("click", (e) -> e.stopPropagation())



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/assets/video_field_view.js.coffee